import React from 'react';

import { Checkbox } from '@ontruck/orc';
import { StyledFilter } from './styled';

const t = {
  label: 'PRIO',
};

const PrioFilter = ({ value, stylingProps, onChange }) => {
  const handleChange = (e, { value }) => {
    onChange(value);
  };

  return (
    <StyledFilter {...stylingProps}>
      <Checkbox
        girded
        contracted
        label={t.label}
        size="M"
        checked={value}
        onChange={handleChange}
      />
    </StyledFilter>
  );
};

PrioFilter.filterName = 'PrioFilter';

export default PrioFilter;
